import Dimens from '../../theme/dimens';
import { useTheme } from '@mui/material';

/**
 * useStyles custom hook generates MUI theme dependent styles for the SignInScreen component.
 * 
 * @returns An object containing the styled classes.
 */
const useStyles = () => {

  const theme = useTheme();

  const styles = {
    innerWrapper: {
      maxWidth: Dimens.loginLayoutWidth,
      p: Dimens.spacing.card,
      borderRadius: Dimens.radius.md,
      bgcolor: theme.palette.background.paper,
      [theme.breakpoints.down('sm')]: {
        borderRadius: 0,
        minWidth: '100%',
        maxWidth: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }
    },
    footer: {
      cursor: 'pointer',
      color: theme.palette.primary.main
    },
    spacer: {
      height: Dimens.spacing.box
    },
    icon: {
      fontSize: Dimens.icon.sm,
      color: theme.palette.text.primary
    }
  };

  return styles;
};

export default useStyles;